import Link from "next/link";
import { VFC } from "react";

interface StepProgressBarProps {
  currentPage: string;
}

export const MenuBar: VFC<StepProgressBarProps> = ({ currentPage }) => {
  return (
    <div className="p-tabs">
      <div className="p-tabs__inner">
        <ul>
          <li className={currentPage === "profile" ? "is-cr" : ""}>
            <Link href="/mypage/profile">
              <a>
                <span>基本情報</span>
              </a>
            </Link>
          </li>
          <li className={currentPage === "history" ? "is-cr" : ""}>
            <Link href="/mypage/history">
              <a>
                <span>
                  過去の
                  <br className="u-sp" />
                  寄付履歴
                </span>
              </a>
            </Link>
          </li>
          <li className={currentPage === "change_card" ? "is-cr" : ""}>
            <Link href="/mypage/change_card">
              <a>
                <span>お支払い方法の変更</span>
              </a>
            </Link>
          </li>
          <li className={currentPage === "change_donation" ? "is-cr" : ""}>
            <Link href="/mypage/change_donation">
              <a>
                <span>寄付内容の変更</span>
              </a>
            </Link>
          </li>
        </ul>
      </div>
    </div>
  );
};
